<template>
  <div class="scheduler">
    <SchedulerSubsSubstituteHours
      v-if="activeUser !== null"
      :item="activeUser"
      :itemBCR="activeUserBCR">
    </SchedulerSubsSubstituteHours>
    <ul class="scheduler__header">
      <li><b>{{ title }}</b></li>
      <div class="do-scroller do-scroller--hide"
           ref="topDiv"
           v-scroll="handleScrollTop">
        <ul class="scheduler__header__times">
          <li v-for="number in hoursInLocale">{{ number | LT }}</li>
        </ul>
      </div>
    </ul>
    <div class="scheduler__container" :class="{'scheduler__container--loading': dataIsLoading}">
      <div class="scheduler__container__loader" v-if="dataIsLoading">
        <Loader></Loader>
      </div>
      <div class="do-scroller__container">
        <div class="do-scroller do-scroller-max-height do-scroller--hide do-scroller__users"
             ref="leftDiv"
             v-scroll="handleScrollLeft"
             :style="{
               maxHeight: schedulerMaxHeight + 'px',
               paddingBottom: isVerticalScrollbar ? '15px' : '0px'
             }">
          <ul class="scheduler__users">
            <!-- <transition-group name="flip-list" tag="ul" class="scheduler__users"> -->
            <li v-for="(item, idx) in items"
                :key="item.id"
                :style="{'height': 40 * rows[item.id] + 'px'}"
                :class="{'item-is-headline': item.headline}">
              <div v-if="item.headline"
                   class="scheduler__users__headline">
                <div class="scheduler__users__user__name">{{ subsTitle }}</div>
                <div class="scheduler__users__user__subpools scheduler__users__user__subpools__title">
                  {{ $t('vue2.sub_scheduler.pool') }}
                </div>
              </div>
              <div v-else
                   class="scheduler__users__user"
                   :class="[
                     {'scheduler__users__user--absence-autogenerated': isAbsenceAutoGenerated(item)},
                     {'scheduler__users__user--not-absent': item.dayAbsence.length < 1}
                     ]">
                <div class="scheduler__users__user__name"
                     @click="setCreateEventOnUserOnNotAbsentUser(item)"
                     :title="i18n.create_activity"
                     v-tippy="{
                arrow: false,
                animateFill: false,
                placement: 'right',
                animation : 'shift-away',
                zIndex: '999999992',
                boundary: 'window',
                onShow: () => item.dayAbsence.length < 1
              }">
                  {{ item.name }}
                  <div class="absence-generated-sign"
                       v-if="isAbsenceAutoGenerated(item)"
                       v-tippy='{ arrow: true, placement : "right", animation : "fade" }'
                       :title="i18n.auto_created">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="tw-icon tw-icon-important">
                      <path class="primary" d="M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20z"/>
                      <path class="secondary"
                            d="M12 18a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm1-5.9c-.13 1.2-1.88 1.2-2 0l-.5-5a1 1 0 0 1 1-1.1h1a1 1 0 0 1 1 1.1l-.5 5z"/>
                    </svg>
                  </div>
                  <DDropdown v-if="item.dayAbsence.length > 0">
                    <ul slot="list" style="width: 180px">
                      <li><a :href="'/calendars/' + item.user_calendar_id" class="marg-5-left text-link"
                             target="_blank">{{ i18n.go_to_calendar }}</a></li>
                      <li @click="setActiveAbsentUser(item)">{{ i18n.add_sub_to_multiple_lessons }}</li>
                      <li @click="setCreateEventOnUser(item)">{{ i18n.create_activity }}</li>
                    </ul>
                  </DDropdown>
                </div>
                <div class="scheduler__users__user__subpools cursor-help"
                     v-if="item.dayAbsence.length === 0"
                     @mouseenter="setActiveUser(item, $event)"
                     @mouseleave="activeUser = null">
                  {{ item.subPoolsDiff | round }}
                </div>
                <div v-else
                     class="scheduler__users__user__handled"
                     :class="{'scheduler__users__user__handled--loading': getIsUserHandlerLoading(item.id)}"
                     :ref="'absence_status_dropdown__parent___' + item.id"
                     @click="setTheAbsentUserHandledDropdown(item)">
                  <div class="scheduler__users__user__handled__handler"
                       :class="schedulerUserHandledCls(item)">
                  </div>
                </div>
              </div>
            </li>
          </ul>
          <!-- </transition-group> -->
        </div>
      </div>
      <div class="scheduler__cal">
        <div class="do-scroller__container">
          <div class="do-scroller do-scroller-max-height do-scroller--hide"
               ref="rightDiv"
               :style="{ maxHeight: schedulerMaxHeight + 'px' }"
               v-scroll="handleScrollRight">
            <ul class="scheduler__cal__ress">
              <ul class="scheduler__cal__ress__items">
                <SchedulerItem
                  v-for="user in items"
                  :key="user.id"
                  :user="user"
                  :locale="locale"
                  :allEvents="allEvents"
                  :isSubStatusPendingActive="isSubStatusPendingActive"
                  :allCalendarsInHash="allCalendarsInHash"
                  :longAbsentListInHash="longAbsentListInHash"
                  @onChooseSubType="onChooseSubType"
                  @rows="setRows($event, user.id)"
                ></SchedulerItem>
              </ul>
              <ul class="scheduler__cal__timeslots">
                <li v-for="n of hoursInLocale.length * 2"></li>
              </ul>
              <SchedulerRulers></SchedulerRulers>
            </ul>
          </div>
          <transition name="zoomIn">
            <div class="sub-popover"
                 v-if="activeEvent && activeEvent.obj">
              <div class="icon__bg-circle close-cross" @click="closePopover">
                <span class="icon-cross2"></span>
              </div>
              <SchedulerPopover
                :activeEventId="activeEvent"
                :user="schedulerUser"
                :locale="locale"
                @chooseSubType="onChooseSubType"
                @removeSubs="removeSubs"
                @clickaway="closePopover"
                @close="closePopover"
                @showLog="showLog"
                @deleteEvent="setDeleteEvent"
                @splitLesson="$emit('splitLesson', $event)"
                @setTheOutOfSchoolLesson="$emit('setTheOutOfSchoolLesson', $event)">
              </SchedulerPopover>
            </div>
          </transition>
        </div>
      </div>
    </div>
    <div class="scheduler__users__user__handled__dropdown"
         v-if="theAbsentUserHandledDropdown !== null"
         ref="absence_status_dropdown"
         v-on-clickaway="closeSubStatusDropdown">
      <div class="popper-arrow"></div>
      <ul class="scheduler__users__user__handled__absense__reasons">
        <li v-for="absence in theAbsentUserHandledDropdown.dayAbsence"
            class="scheduler__users__user__handled__absense__reasons__reason">
          <h4>{{ getAbsenceTitle(absence) }}</h4>
          <ul>
            <li @click="setAbsenceStatus(theAbsentUserHandledDropdown, 0)">
              {{ $t('vue2.sub_scheduler_popover.not_handled') }}
            </li>
            <li @click.stop="setAbsenceStatus(theAbsentUserHandledDropdown, 1)"
                class="scheduler__users__user__handled__absense__reasons__reason--handled">
              {{ $t('vue2.sub_scheduler_popover.handled') }}
            </li>
          </ul>
        </li>
      </ul>
    </div>
    <DModal v-if="theTeacherOrSubObj" @close="setIsModal(false)" :isBgOverlay="true" :show-close="false">
      <div class="do-modal__choose-as-sub-or-teacher" slot="insertComponent">
        <div class="do-modal__header">
          <h2></h2>
          <div class="icon__bg-circle" @click="setIsModal(false)">
            <span class="icon-cross2"></span>
          </div>
        </div>
        <div class="do-modal__body">
          <h2>{{ i18n['should'] }} {{ theSubName }} {{ i18n['be_appointed'] }}?</h2>
          <div class="d-spinner__container" v-if="isLoadingEvent">
            <div class="do-spinner do-spinner--large"></div>
          </div>
          <template v-else>
            <button class="do-bttn do-bttn__option" :class="{'do-bttn--loading': isLoadingEvent}" @click="setAsSub">
              {{ i18n['as_a_substitute'] }}
            </button>
            <button class="do-bttn do-bttn__option" :class="{'do-bttn--loading': isLoadingEvent}" @click="setAsTeacher">
              {{ i18n['as_a_teacher'] }}
            </button>
          </template>
        </div>
      </div>
    </DModal>
    <ModalConfirmation
      v-if="theDeleteEvent"
      :appendToBody="true"
      @close="theDeleteEvent = null"
      @confirm="deleteTheDeleteEvent">
    </ModalConfirmation>
  </div>
</template>

<script>
import SchedulerItem from './SchedulerItem'
import SchedulerRulers from './SchedulerRulers'
import SchedulerSubsSubstituteHours from './SchedulerSubSubstituteHours'
import SchedulerPopover from './SchedulerItemPopover'
import {createPopper} from '@popperjs/core'
import moment from 'moment'
import docendo from '../../../docendo'
import {mixin as clickaway} from 'vue-clickaway'
import Loader from '../../common/Loader'
import DDropdown from '../../common/DDropdown'
import DModal from '../../common/DModal.vue'
import ModalConfirmation from '../../Modals/ModalConfirmation.vue'

const I18N = {
  da: {
    go_to_calendar: 'Se kalender',
    add_sub_to_multiple_lessons: 'Vikardæk flere lektioner',
    auto_created: 'Oprettet automatisk',
    should: 'Skal',
    be_appointed: 'sætttes på som vikar eller lærer',
    as_a_substitute: 'Som en vikar',
    as_a_teacher: 'Som en lærer',
    create_activity: 'Opret aktivitet'
  },
  nb: {
    go_to_calendar: 'Se kalender',
    add_sub_to_multiple_lessons: 'Legg til vikar for flere leksjoner',
    auto_created: 'Løpende lengre fravær',
    should: 'Bør',
    be_appointed: 'settes inn som lærer eller vikar',
    as_a_substitute: 'Som en vikar',
    as_a_teacher: 'Som en lærer',
    create_activity: 'Opprett aktivitet'
  },
  en: {
    go_to_calendar: 'Go to calendar',
    add_sub_to_multiple_lessons: 'Add substitute to multiple lessons',
    auto_created: 'Autogenerated',
    should: 'Should',
    be_appointed: 'be appointed as a substitute teacher or teacher',
    as_a_substitute: 'As a subtitute teacher',
    as_a_teacher: 'As a teacher',
    create_activity: 'Create event'
  }
}

export default {
  mixins: [clickaway],
  components: {
    ModalConfirmation,
    DModal,
    DDropdown,
    SchedulerItem,
    SchedulerRulers,
    SchedulerSubsSubstituteHours,
    SchedulerPopover,
    Loader
  },
  directives: {
    scroll: {
      inserted: function (el, binding) {
        let f = function (evt) {
          if (binding.value(evt, el)) {
            el.removeEventListener('scroll', f)
          }
        }
        el.addEventListener('scroll', f)
      }
    }
  },
  props: {
    date: {
      required: false
    },
    items: {},
    title: {
      type: String,
      default: 'Teachers'
    },
    subsTitle: {
      type: String,
      default: 'Potential Substitutes'
    },
    isSortOnName: {
      type: Boolean,
      default: true
    },
    isSubStatusPendingActive: {
      type: Boolean,
      default: false
    },
    allCalendarsInHash: {
      type: Object,
      default: () => {
      }
    },
    longAbsentListInHash: {
      type: Object,
      default: () => {
      }
    }
  },
  data () {
    return {
      isLoadingEvent: false,
      theTeacherOrSubObj: null,
      isSyncingLeftScroll: false,
      isSyncingRightScroll: false,
      isSyncingTopScroll: false,
      tags: [],
      rows: {},
      activeUser: null,
      activeUserBCR: null,
      subStatusDropdown: null,
      theAbsentUserHandledDropdown: null,
      theUserHandlerLoading: null,
      theDeleteEvent: null,
      schedulerMaxHeight: '100vh',
      isVerticalScrollbar: false
    }
  },
  watch: {
    rows () {
      this.$refs.rightDiv.scrollLeft = 480
      this.$refs.topDiv.scrollLeft = 480
    },
    date () {
      this.closePopover()
    }
  },
  filters: {
    round (num) {
      return Math.round(num)
    }
  },
  computed: {
    locale () {
      return this.$store.getters.locale
    },
    i18n () {
      return I18N[this.locale]
    },
    theSubName () {
      return this.theTeacherOrSubObj && this.theTeacherOrSubObj.userAsSub && this.theTeacherOrSubObj.userAsSub.name ? this.theTeacherOrSubObj.userAsSub.name : 'the teacher'
    },
    dataIsLoading () {
      return this.$store.state.subs.dataIsLoading
    },
    hoursInLocale () {
      let hours = []
      for (let i = 0; i < 24; i++) {
        hours.push(moment().set({hour: i, minutes: 0, seconds: 0}))
      }
      return hours
    },
    isSubScoreActive () {
      return this.$store.state.subs.isSortSubActive
    },
    activeEvent () {
      return this.$store.state.subs.schedulerActiveEvent
    },
    schedulerUser () {
      return this.$store.state.subs.activeUser
    },
    allEventsInAHash () {
      return this.$store.state.subs.allEventsInAHash
    },
    getDate () {
      return this.$store.getters.absentUsersGetDate
    },
    absentUsersHandledHash () {
      return this.$store.getters.absentUsersHandledHash
    },
    allEvents () {
      return this.$store.state.subs.allEvents
    }
  },
  methods: {
    calculateMaxHeight () {
      if (this.$refs.rightDiv) {
        const topOffset = this.$refs.rightDiv.getBoundingClientRect().top
        this.schedulerMaxHeight = window.innerHeight - topOffset // 1rem ≈ 16px
      }
    },
    getIsUsersAbsentHandled (user) {
      return this.absentUsersHandledHash[user.id] ? this.absentUsersHandledHash[user.id] : false
    },
    schedulerUserHandledCls (item) {
      if (!this.isSubStatusPendingActive) {
        return this.getIsUsersAbsentHandled(item) ? 'scheduler__users__user__handled__handler--handled' : null
      } else {
        if (!this.getIsUsersAbsentHandled(item)) {
          return null
        }
        return this.getIsUsersAbsentHandled(item) && this.getIsUsersAbsentHandled(item) === 2 ? 'scheduler__users__user__handled__handler--pending' : 'scheduler__users__user__handled__handler--handled'
      }
    },
    setDeleteEvent (lesson) {
      this.theDeleteEvent = lesson
    },
    deleteTheDeleteEvent () {
      docendo.deleteEvent(this.theDeleteEvent.school_id, this.theDeleteEvent.id,
        success => {
          const event = JSON.parse(success)
          event.calendar_events.forEach(calEvent => {
            if (calEvent.calendar_type === 'user') {
              if (event.away) {
                this.$store.commit('removeAbsenceOnAllUsersWithEvents', {
                  cal_id: calEvent.calendar_id,  // Identify the calendar ID
                  event_id: event.id
                })
              } else {
                this.$store.commit('removeEventOnAllUsersWithEvents', {
                  cal_id: calEvent.calendar_id,  // Identify the calendar ID
                  event_id: event.id
                })
              }
            }
          })
        },
        failure => {
          console.log('failure', failure)
        })
      document.querySelector('body').click()
      this.theDeleteEvent = null
    },
    setSubStatus (lesson, num, teacherToSub) {
      let statusData = this.getSubstitutionStatus(lesson)
      statusData[teacherToSub.user_calendar_id] = {'status': num}
      docendo.updateEvent(lesson.school_id, lesson.id, {substitution_status: JSON.stringify(statusData)}, success => {
        this.$store.commit('updateSubStatusOnEvent', {
          'eventId': lesson.id,
          'status': JSON.stringify(statusData)
        })
      })
    },
    getSubstitutionStatus (lesson) {
      return lesson.substitution_status ? JSON.parse(lesson.substitution_status) : {}
    },
    setAsSub () {
      this.isLoadingEvent = true
      const activeEvent = this.theTeacherOrSubObj.eventToSub
      const teacherToAdd = this.theTeacherOrSubObj.userAsSub
      const teacherToSub = this.theTeacherOrSubObj.userToSub
      if (this.isSubStatusPendingActive) {
        this.setSubStatus(activeEvent, 2, teacherToSub)
      }
      let userEventObj = {cal_id: teacherToAdd.user_calendar_id, event_id: activeEvent.id}
      docendo.eventAddSubstitute(activeEvent.id, teacherToAdd.id, teacherToSub.id, data => {
        this.$store.commit('updateEventOnAllEventsInAHash', JSON.parse(data))
        this.$store.commit('addEventOnAllUsersWithEvents', userEventObj)
        this.isLoadingEvent = false
        this.theTeacherOrSubObj = null
      })
    },
    setAsTeacher () {
      this.isLoadingEvent = true
      const activeEvent = this.theTeacherOrSubObj.eventToSub
      const teacherToAdd = this.theTeacherOrSubObj.userAsSub
      const teacherToSub = this.theTeacherOrSubObj.userToSub
      this.setSubStatus(activeEvent, 1, teacherToSub)
      let userCalIds = activeEvent.calendar_events.map(cal => cal.calendar_id)
      const allCals = userCalIds.concat([teacherToAdd.user_calendar_id])
      const updates = [{event_id: activeEvent.id, calendar_ids: allCals}]
      docendo.updateEvents(activeEvent.school_id, updates, success => {
        this.isLoadingEvent = false
        this.$store.dispatch('getAllDayEvents')
        this.theTeacherOrSubObj = null
      }, failure => {
        console.log('failure', failure)
      })
    },
    onChooseSubType (obj) {
      this.theTeacherOrSubObj = obj
      this.setIsModal(true)
    },
    setIsModal (bool) {
      if (!bool) {
        this.theTeacherOrSubObj = null
      }
    },
    showLog (event) {
      this.$emit('showLog', event)
    },
    removeSubs (data) {
      this.$emit('removeSubs', data)
    },
    setActiveUser (item, e) {
      this.activeUser = item
      this.activeUserBCR = e.target.getBoundingClientRect()
    },
    setRows (obj, userid) {
      this.$set(this.rows, userid, obj.rows)
    },
    handleScrollRight (evt, el) {
      if (!this.isSyncingRightScroll) {
        this.isSyncingLeftScroll = true
        this.isSyncingTopScroll = true
        this.$refs.leftDiv.scrollTop = el.scrollTop
        this.$refs.topDiv.scrollLeft = el.scrollLeft
      }
      this.isSyncingRightScroll = false
    },
    handleScrollLeft (evt, el) {
      if (!this.isSyncingLeftScroll) {
        this.isSyncingRightScroll = true
        this.$refs.rightDiv.scrollTop = el.scrollTop
      }
      this.isSyncingLeftScroll = false
    },
    handleScrollTop (evt, el) {
      if (!this.isSyncingTopScroll) {
        this.isSyncingRightScroll = true
        this.$refs.rightDiv.scrollLeft = el.scrollLeft
      }
      this.isSyncingTopScroll = false
    },
    closePopover (e) {
      if (!this.setActiveUser) {
        return
      }
      this.$store.commit('setActiveUser', null)
      this.$store.commit('setActiveEvent', null)
      this.$store.dispatch('setActiveSchedulerEvent', {
        'left': -10,
        'right': -10,
        'color': '',
        'oldSubScoreMeta': this.subScoreMeta,
        'obj': null
      })
    },
    createPopperForAbsentStatusDropdown (itemId) {
      createPopper(this.$refs['absence_status_dropdown__parent___' + itemId][0], this.$refs['absence_status_dropdown'], {
        placement: 'right-start',
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [0, -10]
            }
          }
        ]
      })
    },
    setIsUserHandlerLoading (itemId) {
      this.theUserHandlerLoading = itemId
    },
    getIsUserHandlerLoading (itemId) {
      return this.theUserHandlerLoading === itemId
    },
    setTheAbsentUserHandledDropdown (user) {
      this.theAbsentUserHandledDropdown = user
      if (!user) {
        return
      }
      setTimeout(_ => {
        this.createPopperForAbsentStatusDropdown(user.id)
      }, 0)
    },
    getIsUserSubstituted (user, lesson) {
      const isUserSubstituted = lesson.calendar_events.some(calEvent => calEvent.substitute_for_user_id === user.id)
      if (isUserSubstituted) {
        return true
      }
    },
    setAbsenceStatus (user, num) {
      // Helper function to group lessons by school_id
      const groupBySchoolId = (lessons) => {
        return lessons.reduce((groups, lesson) => {
          const schoolId = lesson.school_id
          if (!groups[schoolId]) {
            groups[schoolId] = []
          }
          groups[schoolId].push(lesson)
          return groups
        }, {})
      }

      // Handle absence for users with no day events
      if (user.dayEvents.length < 1) {
        user.dayAbsence.forEach(lessonId => {
          const lesson = this.allEventsInAHash[lessonId]
          let statusData = lesson.substitution_status ? JSON.parse(lesson.substitution_status) : {}
          statusData[user.user_calendar_id] = {status: num}

          docendo.updateEvent(lesson.school_id, lesson.id, {substitution_status: JSON.stringify(statusData)}, success => {
            this.$store.commit('updateSubStatusOnEvent', {
              eventId: lesson.id,
              status: JSON.stringify(statusData)
            })
          })
        })
      }

      // Collect lessons to update
      const lessonsToUpdate = user.dayEvents
        .filter(lessonId => {
          const lesson = this.allEventsInAHash[lessonId]
          return !this.isSubStatusPendingActive ? !this.getIsUserSubstituted(user, lesson) : true
        })
        .map(lessonId => {
          const lesson = this.allEventsInAHash[lessonId]
          let statusData = lesson.substitution_status ? JSON.parse(lesson.substitution_status) : {}
          statusData[user.user_calendar_id] = {status: num}

          return {
            ...lesson,
            substitution_status: JSON.stringify(statusData)
          }
        })

      // Group lessons by school_id
      const groupedLessons = groupBySchoolId(lessonsToUpdate)

      this.setIsUserHandlerLoading(user.id)

      // Loop through each school_id group and make API calls
      Object.entries(groupedLessons).forEach(([schoolId, lessons]) => {
        const eventsToUpdate = lessons.map(lesson => ({
          event_id: lesson.id,
          substitution_status: lesson.substitution_status
        }))

        docendo.updateEvents(schoolId, eventsToUpdate, success => {
          if (success) {
            // Commit updates to Vuex store
            eventsToUpdate.forEach(event => {
              this.$store.commit('updateSubStatusOnEvent', {
                eventId: event.event_id,
                status: event.substitution_status
              })
            })
          } else {
            console.error(`Failed to update events for school_id: ${schoolId}`)
          }

          // Reset loading state after all updates
          this.setIsUserHandlerLoading(null)
        })
      })

      // Delay setting the dropdown to null for UI updates
      setTimeout(() => {
        this.setTheAbsentUserHandledDropdown(null)
      }, 0)
    },
    getAbsenceTitle (absenceId) {
      return this.allEventsInAHash[absenceId] && this.allEventsInAHash[absenceId].title ? this.allEventsInAHash[absenceId].title : 'No title'
    },
    closeSubStatusDropdown (evt) {
      let theClassList = evt.target.classList
      if (theClassList.contains('scheduler__users__user__handled__handler') || theClassList.contains('scheduler__users__user__handled')) {
        return
      }
      this.setTheAbsentUserHandledDropdown(null)
    },
    isAbsenceAutoGenerated (item) {
      if (item.dayAbsence.length < 1) {
        return false
      }
      let autoGeneratedToday = false
      item.dayAbsence.forEach(absenceId => {
        let absence = this.allEventsInAHash[absenceId] && this.allEventsInAHash[absenceId] ? this.allEventsInAHash[absenceId] : {}
        let statusObj = absence.substitution_status ? JSON.parse(absence.substitution_status) : {}
        let todayDate = moment(this.date).format('YYYY-MM-DD')
        if (statusObj['extended_at'] && moment(statusObj['extended_at']).isSame(todayDate)) {
          autoGeneratedToday = true
        }
      })
      return autoGeneratedToday
    },
    setActiveAbsentUser (item) {
      this.$store.commit('setActiveAbsentUser', item)
    },
    setCreateEventOnUser (item) {
      const user = item
      const date = moment(this.date)
      this.$emit('setCreateEventOnUser', {user, date})
    },
    setCreateEventOnUserOnNotAbsentUser (item) {
      if (item.dayAbsence.length > 0) {
        return
      }
      this.setCreateEventOnUser(item)
    },
    hasVerticalScrollbar (el) {
      return el.offsetWidth > el.clientWidth
    }
  },
  mounted () {
    this.calculateMaxHeight()
    window.addEventListener('resize', this.calculateMaxHeight)
    const rightDiv = this.$refs.rightDiv
    this.isVerticalScrollbar = this.hasVerticalScrollbar(rightDiv)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.calculateMaxHeight)
  }
}
</script>


<style scoped>
@import '../../../assets/css/variables.css';

.scheduler {
  background: white;
  position: relative;
  height: 100%;
  width: 100%;
}

.scheduler ul {
  margin: 0 !important;
}

.scheduler__header {
  border-bottom: 1px solid #ccc;
  display: flex;
  overflow: hidden;
}

.scheduler__header > li:first-child {
  padding: 4px 0 4px 8px;
}

.scheduler__header > li:first-child,
.scheduler__users {
  min-width: 220px;
  max-width: 220px;
  border-right: 1px solid #ccc;
}

.scheduler__header__times {
  display: flex;
  flex: 1;
}

.scheduler__header__times > li {
  display: flex;
  flex: 1;
  min-width: 80px;
  border: 0 solid #ebeff3;
  border-left-width: 1px;
  text-align: left;
  padding: 4px;
}

.scheduler__users > li {
  border: 0 solid #ebeff3;
  border-bottom-width: 1px;
  display: flex;
  height: 100%;
  align-items: center;
}

.scheduler__users__headline {
  display: flex;
  align-items: center;
  height: 100%;
  user-select: none;
}

.scheduler__users__user {
  display: flex;
  height: 100%;
  width: 220px;
  justify-content: space-between;
  position: relative;
  align-items: center;
}

.scheduler__users__user__name {
  width: 180px;
  padding: 0 8px;
  border-right: 1px solid #cccccc;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  line-height: 1.4;
}

.scheduler__users__user--absence-autogenerated .scheduler__users__user__name {
  justify-content: space-between;
}

.scheduler__users__user__subpools {
  position: relative;
  display: flex;
  width: 40px;
  height: 100%;
  align-items: center;
  justify-content: center;
}

.scheduler__users__user__subpools__meta {
  position: absolute;
  right: 0;
  top: 0;
  background: white;
}

.isSortOnSubPools.scheduler__users__user__subpools__title {
  color: var(--blue);
}

.scheduler__users__user__subpools__title {
  user-select: none;
  font-size: 10px;
}

.sortingIsPos.scheduler__users__user__subpools__title {
  transform: scale(1);
  transition: transform 0.25s;
  cursor: pointer;
}

.sortingIsPos.scheduler__users__user__subpools__title:active {
  transform: scale(0.95);
}

.scheduler__container {
  display: flex;
  position: relative;
}

.scheduler__container.scheduler__container--loading {
  min-width: 600px;
}

.scheduler__container__loader {
  position: absolute;
  background: rgb(255 255 255 / 73%);
  right: 0;
  left: 0;
  z-index: 12;
  bottom: 0;
  top: 0;
  display: flex;
}

.scheduler__cal {
  position: relative;
  flex: 1;
  display: flex;
  overflow: hidden;
}

.scheduler__cal__ress {
  flex: 1;
  display: flex;
  flex-direction: column;
  position: relative;
  min-width: calc(48px * 40px);
}

.scheduler__cal__ress > .scheduler__cal__ress__items > li {
  flex: 1;
  box-sizing: border-box;
  width: 100%;
  border: 1px solid rgba(217, 217, 217, .7);
  border-width: 0 0 1px;
  z-index: 1;
}

.scheduler__users > li:nth-child(even),
.scheduler__cal__ress > .scheduler__cal__ress__items > li:nth-child(even) {
  background-color: rgba(237, 240, 245, 0.4);
}

.scheduler__cal__timeslots {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: stretch;
  justify-content: space-between;
}

.scheduler__cal__timeslots > li {
  position: relative;
  min-width: 40px;
  flex: 1;
  border: 0 solid #ebeff3;
  border-left-width: 1px;
}

.scheduler__cal__timeslots > li:nth-child(2n) {
  border-left-style: dotted;
}

.do-scroller__container {
  overflow: hidden;
}

.do-scroller {
  width: 100%;
  overflow: auto;
}

.do-scroller-max-height {
  overflow: auto;
  overscroll-behavior: contain;
  height: 100%;
  max-height: 100vh;
  margin: 0px;
}

.do-scroller__users.do-scroller-max-height {
  overflow: auto scroll;
  margin: 0px -15px -15px 0px !important;
  min-width: 235px;
  max-width: 235px;
}

.do-scroller.do-scroller--hide {
  margin: 0px 0px -15px;
}

.item-is-headline {
  background-color: #3e4450 !important;
  color: #fff !important;
  font-weight: 700;
  position: relative;
}

.scheduler_user__headline {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  line-height: 40px;
  padding-left: 10px;
}

.sub-popover {
  border-radius: 4px;
  position: absolute;
  top: 0;
  bottom: 15px;
  right: 15px;
  z-index: 500;
  width: 275px;
  min-height: 200px;
  font-size: 14px;
  color: black;
  border-radius: 4px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, .19), 0 6px 6px rgba(0, 0, 0, .23);
  background: #f6f9fc;
}

.close-cross {
  float: right;
  position: absolute;
  top: 0px;
  right: 0px;
  padding: 10px;
  color: #ffffff;
}

.zoomIn-enter-active {
  animation: zoomIn .25s;
}

.zoomIn-leave-active {
  animation: zoomIn .25s reverse;
}

@keyframes zoomIn {
  from {
    opacity: 0;
    transform: scale3d(.3, .3, .3);
  }

  50% {
    opacity: 1;
  }
}

.flip-list-move {
  transition: transform .75s;
}

.flip-list-move-enter, .flip-list-move-leave-to
  /* .list-complete-leave-active below version 2.1.8 */
{
  opacity: 0;
  transform: translateX(-30px);
}

.flip-list-move-leave-active {
  position: absolute;
}

.scheduler__users__user__handled {
  position: relative;
  display: flex;
  width: 40px;
  height: 100%;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.scheduler__users__user__handled.scheduler__users__user__handled--loading:after {
  content: '';
  position: absolute;
  z-index: 2;
  background: transparent;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 2px solid #d0d0d0; /* Light grey */
  border-top: 2px solid var(--purple); /* Blue */
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
}

.scheduler__users__user__handled__handler {
  background-color: #ffffff;
  border: 1px solid #3e4450;
  width: 16px;
  height: 16px;
  border-radius: 50%;
}

.scheduler__users__user__handled__handler.scheduler__users__user__handled__handler--handled {
  background-color: #3ecf8e;
  border-color: #3ecf8e;
}

.scheduler__users__user__handled__handler.scheduler__users__user__handled__handler--pending {
  background-color: #f0b100;
  border-color: #f0b100;
}

.scheduler__users__user__handled__dropdown {
  z-index: 100;
  background-color: #ffffff;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .14), 0 1px 5px 0 rgba(0, 0, 0, .12), 0 3px 1px -2px rgba(0, 0, 0, .2);
  border-radius: 4px;
  width: 140px;
}

.scheduler__users__user__handled__dropdown ul li {
  padding: 8px;
}

.scheduler__users__user__handled__absense__reasons__reason h4 {
  padding: 4px 8px;
}

.scheduler__users__user__handled__absense__reasons__reason li {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.scheduler__users__user__handled__absense__reasons__reason li:hover {
  background-color: #f6f7f8;
}

.scheduler__users__user__handled__absense__reasons__reason li:before {
  content: '';
  background-color: #ffffff;
  border: 1px solid #3e4450;
  width: 12px;
  display: inline-block;
  height: 12px;
  border-radius: 50%;
  margin-right: 6px;
}

.scheduler__users__user__handled__absense__reasons__reason li.scheduler__users__user__handled__absense__reasons__reason--handled:before {
  background-color: #3ecf8e;
  border-color: #3ecf8e;
}

.popper-arrow {
  position: absolute;
  background-color: #ffffff;
  top: 16px;
  left: -5px;
  width: 10px;
  height: 10px;
  transform: rotate(45deg);
  border: 1px solid #ccc;
  border-width: 0 0 1px 1px;
}

.absence-generated-sign {
  display: flex;
  align-items: center;
  padding-left: 5px;
}

.tw-icon {
  width: 1.5rem;
}

.primary {
  fill: #e3a008;
}

.secondary {
  fill: #ffffff;
}

.text-link {
  color: var(--blue);
}

.do-modal__choose-as-sub-or-teacher .do-modal__body {
  padding: 2rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.do-modal__choose-as-sub-or-teacher .do-modal__body h2 {
  margin-bottom: 2rem;
}

.d-spinner__container {
  display: flex;
  align-items: center;
  justify-content: center;
}

.scheduler__users__user.scheduler__users__user--not-absent .scheduler__users__user__name {
  position: relative;
  cursor: pointer;
}

.scheduler__users__user.scheduler__users__user--not-absent .scheduler__users__user__name:after {
  content: '+';
  color: #ffffff;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  border-radius: 50%;
  width: 14px;
  height: 14px;
  background-color: rgb(162, 163, 166);
  opacity: 0;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 1rem;
  transition: box-shadow 0.25s;
}

.scheduler__users__user.scheduler__users__user--not-absent .scheduler__users__user__name:hover:after {
  opacity: 0.8;
  box-shadow: 0 0 0 5px #d0d1d2;
}

</style>



// WEBPACK FOOTER //
// Scheduler.vue?168d3c80